//3d carousel
function disableButtons(selector) {
	$(selector).addClass('noEvents');
	$(selector).attr('disabled', 'disabled');
}

function enableButtons(selector) {
	$(selector).removeClass('noEvents');
	$(selector).removeAttr('disabled');
}

function carousel3DInit(slide, state, $carouselItems, $leftArrow, $rightArrow) {
	var slide = slide || globalVar.slide;
	var state = (slide.data.carousel3D = slide.data.carousel3D || {});
	var $carouselItems = $carouselItems || slide.$.find('.carousel-3d-item__js');
	var $leftArrow = $leftArrow || slide.$.find('.carousel-3d-left__js');
	var $rightArrow = $rightArrow || slide.$.find('.carousel-3d-right__js');

	state.pos = 0;

	//3d css setup
	cssSetup($carouselItems);

	//Makes only the front button clickable
	disableButtons($carouselItems);
	enableButtons($carouselItems[0]);

	$leftArrow.on('click.threedcarousel', function () {
		carousel3DMove('left', slide, state, $carouselItems);
	});
	$rightArrow.on('click.threedcarousel', function () {
		carousel3DMove('right', slide, state, $carouselItems);
	});
}

function cssSetup($carouselItems) {
	var numberOfItems = $carouselItems.length;

	//assign first positions
	$carouselItems.each(function (idx, item) {
		var itemNum = idx + 1;
		$(item).addClass('carousel-3d-item');
		$(item).addClass('carousel-3d-item-' + itemNum);
		$(item).addClass('item' + itemNum + 'of' + numberOfItems);
	});
}

function carousel3DMove(direction, slide, state, $carouselItems) {
	//carouselItem = rotating items/buttons
	var slide = slide || globalVar.slide;
	var state = state || slide.data.carousel3D;
	var $carouselItems = $carouselItems || slide.$.find('.carousel-3d-item__js');

	//pos keeps track of the items's position
	var pos = state.pos;
	//number of items
	var numberOfItems = $carouselItems.length;

	//number for a left turn
	var turn;
	switch (direction) {
		case 'right':
			turn = numberOfItems - 1;
			break;
		case 'left':
			turn = 1;
	}
	//change positions to the left
	$carouselItems.each(function (idx, button) {
		var currentPosition = ((idx + pos) % numberOfItems) + 1;
		var nextPosition = ((idx + turn + pos) % numberOfItems) + 1;

		$(button).removeClass('item' + currentPosition + 'of' + numberOfItems);
		$(button).addClass('item' + nextPosition + 'of' + numberOfItems);

		//Makes only the new front button clickable
		if (nextPosition !== 1) return;

		disableButtons($carouselItems);
		disableButtons(this);
		enableButtons(button);
	});

	//update current position
	state.pos += turn;
}
